import { makeStyles } from "@material-ui/core";
import { mobileModel } from "react-device-detect";

let withNotch = false;

if (mobileModel === "iPhone") {
  if (
    typeof window !== "undefined" &&
    window.screen.availHeight === 812 &&
    window.screen.availWidth === 375
  ) {
    if (window.innerHeight === "375" && window.innerWidth === "812") {
    } else {
      withNotch = true;
    }
  }
}

export default makeStyles((theme) => ({
  mainClass: {
    maxWidth: 600,
    overflow: "hidden",
  },
  content: {
    marginTop: 54,
    height: ({ vhUpdated }) =>
      withNotch ? vhUpdated * 100 - 64 - 56 - 15 : vhUpdated * 100 - 64 - 48,
    overflow: "scroll",
  },
}));
